import WelcomeContainer from "./WelcomeContainer";

export default WelcomeContainer;